import { render, staticRenderFns } from "./background-remover.vue?vue&type=template&id=a6f6467a&scoped=true&"
import script from "./background-remover.vue?vue&type=script&lang=js&"
export * from "./background-remover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f6467a",
  null
  
)

export default component.exports